import React from 'react';
import { Template } from 'devextreme-react';
import DataGrid, { Column, SearchPanel } from 'devextreme-react/data-grid';
import { useMediaQuery, useTheme } from '@material-ui/core';
import {
  useTranslation,
  useMaestroDataSource,
} from '@michelin/central-provider';
import { secondaryLocationsList } from '../../../Types/APITypes';
import { CONTENT_AREA_HEIGHT } from '../../../Utils';
import { RenderCity, RenderShipToInfo } from '../Components/TableColumns';
import { TechServiceAreaLocation } from '../types';

interface TechServiceAreaLocationsListTableProps {
  stNumber: string;
}

export function TechServiceAreaLocationsListTable(props: TechServiceAreaLocationsListTableProps) {
  const {
    stNumber,
  } = props;

  const { t } = useTranslation();
  const theme = useTheme();
  const tabletView = useMediaQuery(theme.breakpoints.down(800));
  const cellView = useMediaQuery(theme.breakpoints.down(500));

  const ds = useMaestroDataSource({
    API: secondaryLocationsList(stNumber),
    componentPlacements: {
      filtersPlacement: tabletView ? 'outside' : 'embeded',
      searchPlacement: cellView ? 'outside' : 'embeded',
    },
  });

  return (
    <>
      <div>
        {tabletView ? ds.renderFilterFields(null, { margin: 10 }) : undefined}
        {cellView ? (
          <div style={{ marginBottom: -10, textAlign: 'right' }}>
            {ds.renderResultsCounter()}
          </div>
        ) : undefined}
      </div>
      <DataGrid
        style={{ height: CONTENT_AREA_HEIGHT }}
        noDataText={t('No locations found...')}
        scrolling={{ mode: 'virtual', rowRenderingMode: 'virtual' }}
        className="freespaced-table"
        dataSource={ds.dataSource}
        allowColumnReordering
        allowColumnResizing
        wordWrapEnabled
        remoteOperations
        columnAutoWidth
        onToolbarPreparing={ds.onToolbarPreparing}
      >
        <Template name="filterFields" render={ds.renderFilterFields} />
        <Template name="resultsCounter" render={ds.renderResultsCounter} />
        <SearchPanel visible highlightSearchText={false} />
        <Column
          caption={t('Secondary ST Locations')}
          cellRender={({ row }) => <RenderShipToInfo loc={row.data as TechServiceAreaLocation} />}
          allowSorting
          dataField="ship_to_number"
          defaultSortOrder="asc"
        />
        <Column
          caption={t('Location Address')}
          cellRender={({ row }) => <RenderCity loc={row.data as TechServiceAreaLocation} />}
          dataField="address"
        />
      </DataGrid>
    </>
  );
}
